import DtvTheme, { colorPalette } from "@directv-digital/dds.ui.dtv-theme";

const bps = DtvTheme.breakpoints;

export const defaultSpacing = {
  margin: '0px',
  padding: '0px 20px',
  backgroundColor: colorPalette?.neutral_white.main,
  [bps.between(bps.values.sm, bps.values.md)]: {
    padding: '0px 32px'
  },
  [bps.up(bps.values.md)]: {
    padding: '0px 144px'
  }

}
// Generated by Copilot- Start - 2026-02-24
export const ssrStyle = {
  root: {
    width: '100%',
    padding: '0px',
    margin: '0px',
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: '20px',
    gap: "10px",
    backgroundColor: colorPalette?.neutral_white.main,
    [bps.down(bps.values.sm)]: {
      gap: "16px"
    }
  },
  selectedChips: {
    backgroundColor: `${colorPalette.jet.main} !important`,
    color: `${colorPalette.neutral_white.main} !important`,
    border: '0px !important'
  },
  titleContainer: {
    display: 'flex',
    justifyContent: 'left',
    alignItems: 'left',
    width: '100%',
    fontSize: '28px !important',
    [bps.between(bps.values.sm, bps.values.md)]: {
      fontSize: '30px !important'
    },
    [bps.up(bps.values.md)]: {
      fontSize: '36px !important'
    }
  },
  titleText: {
    fontWeight: 500,
    lineHeight: '120%',
    letterSpacing: '-0.56px',
    fontSize: '28px !important',
    [bps.between(bps.values.sm, bps.values.md)]: {
      fontSize: '36px !important'
    },
    [bps.up(bps.values.md)]: {
      fontSize: '44px !important'
    }
  },
  zipCodeContainer: {
    width: '100%',
    '& div div': {
      margin: "0px"
    },
    '& #zm-dynamic-block': {
      paddingLeft: "6px"
    },
    '& #zm-dynamic-block div': {
      color: colorPalette?.blue[600],
      fontWeight: 500
    }
  },
  radioContainer: {
    '& div': {
      display: "flex",
      flexDirection: "row",
      justifyContent: "flex-start",
      gap: "30px"
    },
    '& div label': {
      width: 'min-content !important',
      alignItems: 'center',
      [bps.up(bps.values.sm)]: {
        width: "max-content !important",
        margin: "0px"
      }
    }
  },
  genrePacksForm: {
    width: "100%",
    margin: "0",
    display: "flex",
    flexDirection: "column",
    gap: "23px",
    [bps.up(bps.values.sm)]: {
      gap: "24px"
    }
  },
  genrePackagesContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    flexWrap: "wrap",
    width: "100%",
    marginTop: "23px",
    gap: "10px",
    [bps.up(bps.values.sm)]: {
      gap: "12px"
    }
    // '& div div label': {
    //     margin: "10px 0px 10px 0px"
    // }
  },
  genrePackagesCheckBox: {
    width: "50%",
    display: "flex",
    alignItems: "start",
    flexDirection: "column",
    flexWrap: "wrap",
    [bps.up(bps.values.sm)]: {
      width: "30%"
    }
  },
  miniPacksSections: {
    display: 'flex',
    flexDirection: 'column',
    gap: "23px",
    [bps.up(bps.values.sm)]: {
      gap: "24px"
    }
  },
  miniPacksContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    flexWrap: "wrap",
    width: "100%",
    gap: "10px",
    [bps.up(bps.values.sm)]: {
      gap: "12px"
    }
  }
}
// Generated by Copilot- Start - 2026-02-24
